'use client';

import React from 'react';
import { AccordionProvider } from './context/AccordionProvider';
import { twMerge } from 'tailwind-merge';

export type AccordionVariant = 'outlined' | 'soft' | 'plain';
export type AccordionSize = 'sm' | 'md' | 'lg';

interface AccordionProps {
  children: React.ReactNode;
  className?: string;
  sx?: React.CSSProperties;
  variant?: AccordionVariant;
  size?: AccordionSize; // Add size prop
  defaultOpen?: boolean;
}

const Accordion = ({
  children,
  className,
  sx,
  variant = 'outlined', // Default to outlined variant
  size = 'md', // Default to medium size
  defaultOpen = false,
}: AccordionProps): React.ReactElement => {
  const baseStyles = 'w-full flex flex-col'; // Base styles for the container

  const variantStyles: Record<AccordionVariant, string> = {
    outlined: 'border border-neutral-200 overflow-hidden',
    soft: ' overflow-hidden', // Can add bg-neutral-50 dark:bg-neutral-800 later if needed
    plain: '', // No specific container styles for plain
  };

  return (
    <AccordionProvider size={size} defaultOpen={defaultOpen}>
      <div
        className={twMerge(
          baseStyles,
          variantStyles[variant],
          className // User-provided classes override defaults
        )}
        style={sx}
      >
        {children}
      </div>
    </AccordionProvider>
  );
};

export default Accordion;
// Named export for the type
export type { AccordionProps };
